import {IThemeIcons} from '../../architecture/sections/theme-icons.interface';
import {AddIcon} from './icons/add.icon';
import {MrGreenExclusivesIcon} from './icons/side-menu/green-exclusives.icon';
import {ScratchCardsIcon} from './icons/side-menu/scratch-cards.icon';
import {JackpotsIcon} from './icons/side-menu/jackpots.icon';
import {LiveCasinoIcon} from './icons/side-menu/live-casino.icon';
import {NewGamesIcon} from './icons/side-menu/new-games.icon';
import {SlotsIcon} from './icons/side-menu/slots.icon';
import {CasinoGamesIcon} from './icons/side-menu/casino-games.icon';
import {ControlCenterIcon} from './icons/navbar-right-container/control-center.icon';
import {MrGreenLiveExclusiveIcon} from "./icons/live-arena-navbar/mrgreen-live-exclusive.icon";
import {AppHeaderSportIcon} from "./icons/header-navbar/app-header-sport.icon";
import {AppHeaderCasinoIcon} from "./icons/header-navbar/app-header-casino.icon";
import {BlogIcon} from './icons/side-menu/blog.icon';
import {HomeIcon} from './icons/side-menu/home.icon';
import {VipIcon} from './icons/side-menu/vip.icon';
import {PromotionsIcon} from './icons/side-menu/promotions.icon';
import {AppHeaderPokerIcon} from "./icons/header-navbar/app-header-poker.icon";

export const MrGreenIcons: Partial<IThemeIcons> = {
    addIcon: AddIcon,
    appHeaderSportIcon: AppHeaderSportIcon,
    appHeaderCasinoIcon: AppHeaderCasinoIcon,
    appHeaderPokerIcon: AppHeaderPokerIcon,
    sideMenuHome: HomeIcon,
    sideMenuBlog: BlogIcon,
    sideMenuPromotions: PromotionsIcon,
    sideMenuExclusive888: MrGreenExclusivesIcon,
    sideMenuScratchCards: ScratchCardsIcon,
    sideMenuJackpots: JackpotsIcon,
    sideMenuLiveCasino: LiveCasinoIcon,
    sideMenuNewGames: NewGamesIcon,
    sideMenuSlots: SlotsIcon,
    sideMenuCasinoGames: CasinoGamesIcon,
    sideMenuVip: VipIcon,
    controlCenterIcon: ControlCenterIcon,
    tripleEightExclusiveIcon: MrGreenLiveExclusiveIcon

};

